import { defaultPageId } from '../pages/defaultPageId';

export function getOrganizationUrl(organization) {
  if (organization) {
    const url = '/account/' + organization.id;
    return (
      url +
      '/' +
      (organization.message === 'startup'
        ? 'news'
        : organization.pending
          ? 'prepare'
          : organization.upgradable
            ? 'upgrade'
            : defaultPageId)
    );
  } else {
    return '';
  }
}
